import { LotBreakdownDetail, Order } from '@/types/fulfill/inventoryHistory';

export const mapLotBreakdown = (order: Order): LotBreakdownDetail[] =>
  (order.lots ?? []).map((lot) => ({
    lotId: lot.id,
    lotName: lot.lotName,
    expiresAt: lot.expiresAt,
    quantityReceived: lot.quantityIn,
  }));
